import { getSettingData,changeSetting } from "@/api/myPractice"
import { isObjEmpty,preparePayload } from "./helper";

const notificationPerferences = {
    namespaced: true,
    state: {
        old_personal: {},
        old_practice: {},
        infoURL: '/setting/getTestResultSetting',
        postpracticeURL: '/setting/setTestResultSettingClinic',
        postpersonalURL: '/setting/setTestResultSettingCustomer'
    },
    getters: {
        old_practice: state => state.old_practice,
        old_personal: state => state.old_personal,
        personalURL: state => state.postpersonalURL,
        practiceURL: state => state.postpracticeURL,
        autoRedrawNotification: state => (tab) => {
            if (tab === "clinic")
                return state.old_practice.notifyCustomerWhenAutomaticRedraw;
            else return state.old_personal.notifyCustomerWhenAutomaticRedraw;
        }
    },
    mutations: {
        SET_PRACTICE_DATA(state, practice_obj) {
            state.old_practice = practice_obj
        },
        SET_PERSONAL_DATA(state, personal_obj) {
            state.old_personal = personal_obj
        },
        SET_DEFAULT(state) {
            state.old_personal = {}
            state.old_practice = {}
        },
    },
    actions: {
        async getSettingData({ state, commit }) {
            if (isObjEmpty(state.old_personal)) {
                const res = await getSettingData(state.infoURL);
                commit("SET_PRACTICE_DATA", res.data.practice)
                commit("SET_PERSONAL_DATA", res.data.personal)
            }
        },
        setPracticeData({ commit }, practiceData) {
            commit("SET_PRACTICE_DATA", practiceData)
        },
        setPersonalData({ commit }, personalData) {
            commit("SET_PERSONAL_DATA", personalData)
        },
        async saveNewPracticeSetting({state,commit},newObj){
            const payload =preparePayload("notificationPerferences",state.old_practice,newObj)
            await changeSetting(state.postpracticeURL, payload);
            commit("SET_PRACTICE_DATA",{...state.old_practice,...newObj})
        },
        async saveNewPersonalSetting({state,commit},newObj){
            const payload =preparePayload("notificationPerferences",state.old_personal,newObj)
            await changeSetting(state.postpersonalURL, payload);
            commit("SET_PERSONAL_DATA",{...state.old_personal,...newObj})
        }
    },
}


export default notificationPerferences;